import {
  NotificationReadModel,
  WorkflowOverdueMessage,
  WorkflowReminder,
} from '@/client/services/api/graphql/gql/graphql';

// ! Since cadence data is stored on the workflow, we only need the message data for the notificatons builder and associated lists

export const extractNotificationMessage = (
  notification: NotificationReadModel | WorkflowReminder | WorkflowOverdueMessage,
) =>
  notification.__typename === 'NotificationReadModel'
    ? notification
    : 'message' in notification
    ? notification.message
    : notification;
